<template>
  <!-- 试卷预览 -->
  <div class="examV">
    <div class="eaxmView">
      <div class="examView_top">
        <h1>{{ title }}</h1>
        <p>{{ count }}道题题目,{{ desc }}</p>
        <P
          >总分：{{ score }}分<span>及格：{{ pass }}分</span></P
        >
      </div>
      <div class="examView_con">
        <ul>
          <li v-for="(item, ix) in ViewList" :key="ix">
            <div class="examTitle">
              <span
                >{{ ix + 1 }}.【{{ item.q_type | judgeLX }}】{{
                  item.questions
                }}
                <b>({{ item.scores }}分)</b></span
              >
            </div>
            <p
              v-for="(a, index) in item.answer"
              v-if="item.q_type == 5 || item.q_type == 1"
              :key="index"
            >
              {{ answerList[index] }}.{{ a }}
            </p>
            <p v-else>{{ item.q_type | judgeLX }}{{ index + 1 }}：{{ a }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="examView_footer">
      <el-button @click="hrefTo">返 回</el-button>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "previewTest",
  data() {
    return {
      ViewList: [],
      answerList: ["A", "B", "C", "D", "E", "F", "G"],
      id: this.$route.query.id,
      title: "",
      pass: "",
      score: "",
      desc: "",
      count: "",
    };
  },
  filters: {
    judgeLX: function (value) {
      var returnValue = "";
      var val = parseInt(value);
      switch (val) {
        case 1:
          returnValue = "单选题";
          break;
        case 2:
          returnValue = "判断题";
          break;
        case 3:
          returnValue = "填空题";
          break;
        case 4:
          returnValue = "简答题";
          break;
        case 5:
          returnValue = "多选题";
          break;
      }
      return returnValue;
    },
  },
  methods: {
    hrefTo() {
      this.$router.go(-1);
    },
  },
  mounted() {
    var data = {
        service: "Exampaper.Paperview",
        p_id: this.id,
      },
      list = [];

    this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
      this.title = res.data.data.p_name;
      this.desc = res.data.data.p_desc;
      this.pass = res.data.data.p_pass;
      this.score = res.data.data.p_scores;
      this.count = res.data.count;
      for (var i = 0; i < res.data.data.question.length; i++) {
        list.push(res.data.data.question[i]);
      }
      for (let a in list) {
        console.log(list[a].answer);
      }
      this.ViewList = list;
    });
  },
};
</script>
<style>
@import "../../../assets/css/task.css";
.eaxmView {
  min-height: calc(100vh - 200px);
}
</style>


// WEBPACK FOOTER //
// src/components/scholl/previewTest/previewTest.vue